<div
  class="cursor-pointer button button_google button_standard button_centered"
  (click)="onSignInWithGoogle()"
>
  <img src="assets/google-icon.svg" width="64" height="64" alt="Google icon" />
  Sign in with Google
</div>
